import React from "react"
import { Accordion } from "components/accordion/Accordion"
import { AccordionItem } from "components/accordion/AccordionItem"
import { AccordionPanel } from "components/accordion/AccordionPanel"
import { AccordionToggle } from "components/accordion/AccordionToggle"
import { Content } from "components/content/Content"
import { FAQ } from "./SingleFAQ/FAQ"
import { FAQAnswer } from "./SingleFAQ/FAQAnswer"
import { FAQQuestion } from "./SingleFAQ/FAQQuestion"
import { Image } from "components/image/Image"
import type { FaqsGroup } from "./faq-types"

import "./faq.module.scss"

interface FAQGroupBlockProps {
  faqs: FaqsGroup
  isCollapsable?: boolean
}

export const FAQGroupBlock = ({
  faqs,
  isCollapsable = false,
}: FAQGroupBlockProps) => {
  const getCollapsableFAQGroup = (isCollapsable: boolean) => {
    if (isCollapsable) {
      return (
        <Accordion isFAQ firstActivePanel={faqs[0].id}>
          {faqs?.map(faq => {
            const { answer, id, image, question } = faq
            return (
              <AccordionItem key={id} id={id}>
                <AccordionToggle>{question}</AccordionToggle>
                <AccordionPanel>
                  {answer && (
                    <Content
                      content={answer.data?.answer}
                      styleListsAsGrid={false}
                    />
                  )}
                    {image?.length > 0 && image[0] && (
                      <Image
                        alt={image[0]?.alternativeText ?? ""}
                        className="fr-faq-group-block__image"
                        image={image[0]}
                        objectFit="contain"
                        style={{ maxWidth: image[0].width, height: "auto" }}
                      />
                    )}
                </AccordionPanel>
              </AccordionItem>
            )
          })}
        </Accordion>
      )
    }
  }

  return (
    <div className="fr-faq-group-block">
      {!isCollapsable &&
        faqs?.map(faq => {
          const { answer, id, image, question } = faq
          
          return (
            <FAQ key={id} image={image?.length > 0 && image[0]}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>
                {answer && (
                  <Content
                    content={answer.data?.answer}
                    styleListsAsGrid={false}
                  />
                )}
              </FAQAnswer>
            </FAQ>
          )
        })}

      {getCollapsableFAQGroup(isCollapsable)}
    </div>
  )
}
